export const SEARCH_INPUT_ID = "professionMatrixCardSearchingValue";
